/**
 *@file fdFilter.js
 *@version 1.0.1
 *@author wuwg
 *@createTime 2019/10/17 - 20:47
 *@updateTime 2019/10/17 - 20:47
 *@see [jsDoc中文文档]{@link  http://www.dba.cn/book/jsdoc/JSDOCKuaiBiaoQianBLOCKTAGS/CONSTRUCTS.html}
 @description fdFilter.js 的描述
 */
import Vue from 'vue';
import capitalize from './capitalize/index.js';
// 点击外围
Vue.filter('capitalize', capitalize);




// WEBPACK FOOTER //
// ./src/js/app/filter/fdFilter.js